import { render } from "./pb-meriteteam.vue?vue&type=template&id=37e1b097"
import script from "./pb-meriteteam.vue?vue&type=script&lang=js"
export * from "./pb-meriteteam.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__